// eslint-disable-next-line complexity
export const getFlagForLanguage = (
    language: string,
    fallbackReturnLanguage = true,
) => {
    //At the time of implementation, this list probably does not have 100% coverage
    switch (language) {
        case 'af':
            return '🇿🇦'; // Afrikaans
        case 'am':
            return '🇪🇹'; // Amharic
        case 'ar':
            return '🇸🇦'; // Arabic
        case 'az':
            return '🇦🇿'; // Azerbaijani
        case 'be':
            return '🇧🇾'; // Belarusian
        case 'bg':
            return '🇧🇬'; // Bulgarian
        case 'bn':
            return '🇧🇩'; // Bengali
        case 'bs':
            return '🇧🇦'; // Bosnian
        case 'ca':
            return '🇪🇸'; // Catalan
        case 'cs':
            return '🇨🇿'; // Czech
        case 'cy':
            return '🏴󠁧󠁢󠁷󠁬󠁳󠁿'; // Welsh
        case 'da':
            return '🇩🇰'; // Danish
        case 'de':
            return '🇩🇪'; // German
        case 'de_AT':
            return '🇦🇹'; // German (Austria)
        case 'de_CH':
            return '🇨🇭'; // German (Switzerland)
        case 'el':
            return '🇬🇷'; // Greek
        case 'en':
            return '🇺🇸/🇬🇧'; // English (generic)
        case 'en_GB':
            return '🇬🇧'; // English (UK)
        case 'en_US':
            return '🇺🇸'; // English (US)
        case 'es':
            return '🇪🇸'; // Spanish
        case 'es-ES':
            return '🇪🇸'; // Spanish
        case 'es-419':
            return '';
        case 'es_MX':
            return '🇲🇽'; // Spanish (Mexico)
        case 'et':
            return '🇪🇪'; // Estonian
        case 'eu':
            return '🇪🇸'; // Basque
        case 'fa':
            return '🇮🇷'; // Persian (Farsi)
        case 'fi':
            return '🇫🇮'; // Finnish
        case 'fo':
            return '🇫🇴'; // Faroese
        case 'fr':
            return '🇫🇷'; // French
        case 'fr_CA':
            return '🇨🇦'; // French (Canada)
        case 'fr_CH':
            return '🇨🇭'; // French (Switzerland)
        case 'ga':
            return '🇮🇪'; // Irish
        case 'gl':
            return '🇪🇸'; // Galician
        case 'he':
            return '🇮🇱'; // Hebrew
        case 'hi':
            return '🇮🇳'; // Hindi
        case 'hr':
            return '🇭🇷'; // Croatian
        case 'hu':
            return '🇭🇺'; // Hungarian
        case 'hy':
            return '🇦🇲'; // Armenian
        case 'id':
            return '🇮🇩'; // Indonesian
        case 'is':
            return '🇮🇸'; // Icelandic
        case 'it':
            return '🇮🇹'; // Italian
        case 'ja':
            return '🇯🇵'; // Japanese
        case 'ka':
            return '🇬🇪'; // Georgian
        case 'kk':
            return '🇰🇿'; // Kazakh
        case 'km':
            return '🇰🇭'; // Khmer
        case 'kn':
            return '🇮🇳'; // Kannada
        case 'ko':
            return '🇰🇷'; // Korean
        case 'ku':
            return '🇮🇶'; // Kurdish
        case 'ky':
            return '🇰🇬'; // Kyrgyz
        case 'lt':
            return '🇱🇹'; // Lithuanian
        case 'lv':
            return '🇱🇻'; // Latvian
        case 'mk':
            return '🇲🇰'; // Macedonian
        case 'ml':
            return '🇮🇳'; // Malayalam
        case 'mn':
            return '🇲🇳'; // Mongolian
        case 'ms':
            return '🇲🇾'; // Malay
        case 'mt':
            return '🇲🇹'; // Maltese
        case 'nb':
            return '🇳🇴'; // Norwegian Bokmål
        case 'ne':
            return '🇳🇵'; // Nepali
        case 'nl':
            return '🇳🇱'; // Dutch
        case 'nl-NL':
            return '🇳🇱'; // Dutch NL
        case 'nl-BE':
            return '🇧🇪'; // Dutch BE
        case 'nn':
            return '🇳🇴'; // Norwegian Nynorsk
        case 'no':
            return '🇳🇴'; // Norwegian
        case 'pl':
            return '🇵🇱'; // Polish
        case 'pt':
            return '🇵🇹'; // Portuguese
        case 'pt_BR':
            return '🇧🇷'; // Portuguese (Brazil)
        case 'ro':
            return '🇷🇴'; // Romanian
        case 'ru':
            return '🇷🇺'; // Russian
        case 'sk':
            return '🇸🇰'; // Slovak
        case 'sl':
            return '🇸🇮'; // Slovenian
        case 'sq':
            return '🇦🇱'; // Albanian
        case 'sr':
            return '🇷🇸'; // Serbian
        case 'sv':
            return '🇸🇪'; // Swedish
        case 'sw':
            return '🇰🇪'; // Swahili
        case 'ta':
            return '🇱🇰'; // Tamil
        case 'te':
            return '🇮🇳'; // Telugu
        case 'th':
            return '🇹🇭'; // Thai
        case 'tl':
            return '🇵🇭'; // Filipino
        case 'tr':
            return '🇹🇷'; // Turkish
        case 'uk':
            return '🇺🇦'; // Ukrainian
        case 'ur':
            return '🇵🇰'; // Urdu
        case 'uz':
            return '🇺🇿'; // Uzbek
        case 'vi':
            return '🇻🇳'; // Vietnamese
        case 'zh':
            return '🇨🇳'; // Chinese (generic)
        case 'zh_CN':
            return '🇨🇳'; // Chinese (Simplified)
        case 'zh_TW':
            return '🇹🇼'; // Chinese (Traditional)
        default:
            return fallbackReturnLanguage ? language : ''; // No flag found
    }
};
